// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3lwRP","itemTitle":"ClientEmergencyInfo_itemTitle__1ntUT","itemText":"ClientEmergencyInfo_itemText__3mbrC"};